import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getBlosterList = (page, pagesize, search, id, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bloster/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            id: id,
            ordering: ordering
        }
    });
};


const getBlosterDropdown = (page, pagesize, search, id, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bloster/', {
        headers: authHeader(), params: {
            fields: 'id,bloster_no,deleted',
            page: page,
            pagesize: pagesize,
            search: search,
            id: id,
            ordering: ordering
        }
    });
};

const getArchiveBlosterList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bloster/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};
const createBloster = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/bloster/`,
        formData,
        {
            headers: authHeader(),
        },
    );
};
const updateBloster = (id, formData) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/bloster/${id}/`,
        formData,
        {
            headers: {
                ...authHeader(), // Include your authorization header
                'Content-Type': 'multipart/form-data', // Specify multipart type
            },
        }
    );
};
const deleteBloster = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/bloster/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const deleteImageBloster = (id, formPayload) => {
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/delete-bloster-files/${id}/`, // Include `id` in the URL
        {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
            },
            data: formPayload, // Pass the payload in the request body
        }
    );
};
const getDieBolsterById = (id) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/bloster/', {
        headers: authHeader(), params: {
            id: id
        }
    });
};
const unArchiveBloster = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/bloster/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const blosterService = {
    getBlosterList,
    getArchiveBlosterList,
    createBloster,
    updateBloster,
    deleteBloster,
    unArchiveBloster,
    deleteImageBloster,
    getDieBolsterById,
    getBlosterDropdown,
};

export default blosterService;
